export default __webpack_public_path__ + "static/media/539.8c2ce2e5.jpg";